/* eslint-disable max-len */
import React, {useState} from 'react'
import { baseURL, CDN } from '../../../constants';
import ReactPlayer from 'react-player'



const VideoPlayerModal = ({setVideoplayerPopup, videoPlayerPopup, selectedResource,setSelectedResource }) => {
    return (
      
        <div className={`modal fade fixed top-0 left-0 ${videoPlayerPopup === true ? 'show' : 'hidden'} w-full h-full outline-none overflow-x-hidden overflow-y-auto`} id="videoModal" tabIndex="-1" aria-labelledby="videoModal" aria-modal="true" role="dialog">
            <div className="modal-dialog modal-dialog-centered relative w-auto pointer-events-none md:min-w-[750px] sm:min-w-[500px] min-w-full mx-auto px-5 md:px-9" style={{ margin:'auto' }}>
                <div className="modal-content border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current">
                    <span className="absolute sm:top-[-22px] sm:right-[-68px] -right-4 -top-4 cursor-pointer" data-bs-dismiss="modal" aria-label="Close">
                        <img src="/images/mdi_close-circle-outline.svg" alt="close-icon" onClick={() => setVideoplayerPopup(false)} className="sm:w-auto sm:h-auto w-[18px] h-[18px]"/>
                    </span>
                    <div className="modal-body w-full">
                        <div className="w-full cursor-pointer">
                            <ReactPlayer playing={videoPlayerPopup ? true : false} controls url={`${CDN}/${selectedResource.document}`} width='100%'
                                height='100%'
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>       
    )
}

export default VideoPlayerModal
